import { makeAutoObservable } from 'mobx';
import ErrorBoundaryStore from '../error-boundary-store/error-boundary-store';
import PodiumInfoStore from '../podium-info-store/podium-info-store';
import { TGraphQLSubscriptions } from '../../api/graphql-api-client/graphql-api-client';
import { getErrorBoundaryStore } from '../error-boundary-store/error-boundary-store-instanse';
import {
  IKnovioCommand,
  IOnKnovioPublish,
  onKnovioCommandSubscription,
  onKnovioPublishCommandSubscription
} from '../../api/dao/live-stream-status-dao';
import { LiveStreamStatus } from '../../constans/presenter-enums';
import { liveStreamStatusFromApi } from '../../constans/presenter-constansts';
import { getPodiumInfoStore } from '../podium-info-store/podium-info-store-instance';
import { getLivePresentationInfoApi } from './../../api/dao/presenter-slide-dao';

class LiveStreamStatusStore {

  public liveStreamStatus: LiveStreamStatus;
  public livePresentationId: number | null;

  constructor (
    private readonly errorBoundary: ErrorBoundaryStore = getErrorBoundaryStore(),
    private readonly podiumInfoStore: PodiumInfoStore = getPodiumInfoStore(),
  ) {
    this.init();
  }

  public getLiveInfoForStatus = async (): Promise<void> => {
    const presentationId: string | null = this.podiumInfoStore.getPresentationId();

    if(!presentationId) return;

    try {
      const res = await getLivePresentationInfoApi(presentationId);
      if (res.id) {
        this.livePresentationId = res.id;
        this.liveStreamStatus = liveStreamStatusFromApi(res.live_status);
      }
    } catch(e) {
      // Ignore this block since we call this API for VOD presentations also
    }
  };

  private onKnovioPublishCommandCallback = (data: { onKnovioPublishCommand: IOnKnovioPublish }): void => {
    const { onKnovioPublishCommand: knovioPublishCommand } = data;
    this.liveStreamStatus = knovioPublishCommand.liveCommand.type;
  };

  private onKnovioCommandCallback = (data: { onKnovioCommand: IKnovioCommand }): void => {
    const { onKnovioCommand: knovioCommand } = data;
    this.liveStreamStatus = knovioCommand.type;
  };

  public onKnovioCommand = (): TGraphQLSubscriptions => {
    return onKnovioCommandSubscription(this.livePresentationId, this.onKnovioCommandCallback, () => this.onKnovioCommand());
  };

  public onKnovioPublishCommand = (): TGraphQLSubscriptions => {
    return onKnovioPublishCommandSubscription(this.livePresentationId, this.onKnovioPublishCommandCallback, () => this.onKnovioPublishCommand());
  };

  public getLivePresentationId = (): number | null => {
    return this.livePresentationId;
  };

  public get liveStatus (): LiveStreamStatus {
    return this.liveStreamStatus;
  }

  private init () {
    makeAutoObservable(this);
    this.liveStreamStatus = LiveStreamStatus.STAND_BY;
    this.livePresentationId = null;
  }
}

export type TLiveStreamStatusStore = LiveStreamStatusStore;

export default LiveStreamStatusStore;
